import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__Skeleton_module_js_1e0619db__ from "./Skeleton.module.js";
function Skeleton({ width, height }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: __WEBPACK_EXTERNAL_MODULE__Skeleton_module_js_1e0619db__["default"].skeleton,
        style: {
            width,
            height
        }
    });
}
export { Skeleton as default };

//# sourceMappingURL=Skeleton.js.map